var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,10L20,10c0-0.1-0.1-0.2-0.1-0.2c-1-1.1-2-2.2-3.1-3.3l-2.4-2.6c-0.2-0.2-0.3-0.2-0.4-0.2 c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.2,0,0.3,0.2,0.5l4,4.4c0,0,0.1,0.1,0.1,0.1l0.5,0.5L6,9.7c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0 c-0.2,0-0.4,0.2-0.4,0.5c0,0.2,0,0.4,0.4,0.5c0.1,0,0.2,0,0.3,0l11.9,0l0.6,0l-0.7,0.7c-0.1,0.1-0.3,0.3-0.4,0.4l-0.3,0.3 c-1.1,1.2-2.2,2.4-3.4,3.7c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0,0,0,0c0.1,0,0.2-0.1,0.3-0.2c1.8-2,3.6-4,5.5-5.9 C20,10.3,20,10.1,20,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,18.2c-1.1,0-2.1,0-3.2,0l-1.6,0v-16h1.4c1.1,0,2.2,0,3.3,0c0.1,0,0.2,0,0.3,0c0.2,0,0.3-0.2,0.3-0.3 c0-0.2-0.1-0.4-0.2-0.5c-0.1,0-0.2,0-0.4,0c-1.2,0-2.4,0-3.6,0l-1,0l-0.2,0c-0.1,0-0.2,0-0.4,0c-0.4,0-0.5,0.1-0.5,0.5v17.3l5.6,0 c0.1,0,0.2,0,0.2,0c0.1,0,0.2-0.1,0.3-0.3c0.1-0.2,0-0.3-0.1-0.5C8,18.2,7.9,18.2,7.7,18.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6719d5ff.svg";
export { ForwardRef as ReactComponent };